<template>
  <div class="cb_sim_container js-form-wrapper">
    <div class="cb_sim_results form-wrapper js-form-wrapper">
      <h2>
        {{ t("simulation") }}
        <span class="refreshsim" @click="refreshsim">
          <font-awesome-icon icon="redo" />
        </span>
      </h2>
      <input
        v-if="childsfinished() || children.length < 1"
        type="button"
        @click="addChild"
        class="btn cb_sim_btn_blue"
        :value="t('add child')"
      />
      <div v-if="!show && !isEmpty(result) && childsfinished()">
        <input
          type="button"
          @click="toggleShow"
          class="btn cb_sim_btn_blue"
          :value="t('show results')"
        />
      </div>
      <div v-if="show">
        <hr />
        <div v-for="(child, index) in result" :key="index">
          <h3 class="cb_sim_calcfor" v-if="index">
            {{ t("calculation for") }} {{ index }}:
          </h3>
          <ul class="cb_sim_result">
            <li v-for="(result, resindex) in result[index]" :key="resindex">
              <span class="cb_sim_resultname">{{ t(resindex) }} :</span>
              <span class="cb_sim_resultamount"
                >{{ parseFloat(result).toFixed(2) }} &euro;</span
              >
            </li>
          </ul>
        </div>
        <h3 class="cb_sim_h3_totalresult" v-if="sumresult > 0">
          <span class="cb_sim_resultname">{{ t("total") }} :</span>
          <span class="cb_sim_resultamount">{{ sumresult }} &euro;</span>
        </h3>
      </div>
      <div v-if="storedChildren.length > 0">
        <hr />
        <h3 class="cb_sim_h3_totalresult">{{ t("saved children") }}</h3>
        <ul class="cb_sim_result">
          <li v-for="(child, index) in storedChildren" :key="index">
            {{ child.naam }}
            <font-awesome-icon
              icon="folder-open"
              class="cb_btn cb_btn_noborder"
              @click="loadChild(index)"
            />&nbsp;
            <font-awesome-icon
              icon="trash-alt"
              class="cb_btn cb_btn_noborder"
              @click="removeChild(index)"
            />
          </li>
        </ul>
      </div>
      <div id="cb_sim_disclaimer">{{ t("disclaimer") }}</div>
    </div>

    <div class="cb_sim_children form-wrapper js-form-wrapper">
      <div v-if="children.length == 0" v-html="t('welcome_screen')"></div>
      <div v-if="children.length > 0">
        <div v-for="(child, index) in children" :key="child.key" ref="child">
          <Child
            ref="child"
            :naam="child.naam"
            :geboortedatum="child.birthDate"
            :index="index"
            :jongsteCounter="child.jongsteCounter"
            :childCounter="child.childCounter"
            :translations="translations"
            :translationAnswers="translationAnswers"
            :globalQuestions="global_questions"
            :childCountTotal="childCountTotal"
            :childCountTotalBXL="children.length"
            :gezinHeeftPost2019Kind="gezinHeeftPost2019Kind"
            :storedData="child.storedData"
            :region="region"
            :lang="lang"
            @results="getResultsHandler"
            @updatename="updatename"
            @updateBirthdate="updateBirthdate"
            @deleteChild="deleteChild"
            @globalQuestion="globalQuestion"
            @continuedRight="continuedRight"
            @resort="sortChildren"
            @wezentoeslag="wezentoeslag"
            @gitcorr="gitcorrection"
            :key="lang + region"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadcockpit } from "@/components/mixins/mixins";
import { library } from "@fortawesome/fontawesome-svg-core";
import axios from "axios";
import uuid from "uuid/v4";
import VueSticky from "vue-sticky"; // Es6 module
import Child from "./Child.vue";

import { faFolderOpen, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faFolderOpen);
library.add(faTrashAlt);

export default {
  name: "CB",
  components: {
    Child,
    FontAwesomeIcon,
  },
  mixins: [loadcockpit],
  props: { name: String, birthdate: String },
  directives: {
    sticky: VueSticky,
  },
  data() {
    return {
      show: false,
      result: {},
      children: [],
      summary: [],
      global_questions: {},
      sumresult: 0,
      endchildren: {},
      endresult: {},
      translations: {},
      savedChildren: [],
      childCountTotal: 0,
      gezinHeeftPost2019Kind: 0,
      storedChildren: [],
      translationAnswers: {},
      GIT_corr: 0,
    };
  },
  computed: {
    nameAndBirthdate() {
      return (
        this.name &&
        this.name.length > 0 &&
        this.birthdate &&
        this.birthdate.length > 0
      );
    },
  },
  created() {
    var key = "account-7aebb02aea92aede3990182e509034";
    axios
      .get(
        "https://parentia.rubico.be/cockpit/api/lokalize/project/CB_Simulation?token=account-e3a92457d6330430ec16e25fde9f42",
      )
      .then((response) => {
        this.translations = response.data;
      });
    axios
      .get(
        "https://parentia.rubico.be/cockpit/api/lokalize/project/CB_Simulation_Answers?token=account-e3a92457d6330430ec16e25fde9f42",
      )
      .then((response) => {
        this.translationAnswers = response.data;
      });
    //load stored Children
    for (var key in localStorage) {
      if (key.includes("cbsim_child_")) {
        this.storedChildren.push(JSON.parse(localStorage.getItem(key)));
      }
    }
  },
  watch: {
    children: function () {
      this.sortChildren();
    },
    nameAndBirthdate(newVal) {
      if (newVal) {
        console.log("name", this.name, "birthdate", this.birthdate);
        this.children.push({
          key: uuid(),
          naam: this.name,
          jongsteCounter: "1",
          childCounter: 1,
          birthDate: this.birthdate,
          continuedRight: "nieuw recht",
          storedData: {},
          wezentoeslag: false,
        });
        this.show = false;
      }
    },
  },
  methods: {
    toggleShow: function () {
      this.show = !this.show;
    },
    childsfinished: function () {
      for (var i in this.$refs.child) {
        if (this.$refs.child[i].finished === false) {
          return false;
        }
      }
      return true;
    },
    deleteChild: function (index, naam) {
      this.children.splice(index, 1);
      delete this.endresult[naam];
      delete this.result[naam];
      this.gitcorr = false;
      this.sortChildren();
    },

    removeChild: function (index) {
      localStorage.removeItem("cbsim_child_" + this.storedChildren[index].naam);
      this.storedChildren.splice(index, 1);
    },
    loadChild: function (index) {
      var a = this.children.push({
        key: uuid(),
        naam: this.storedChildren[index]["naam"],
        jongsteCounter: "",
        childCounter: 1,
        birthDate: this.storedChildren[index]["geboortedatum"],
        continuedRight: this.storedChildren[index]["vlaanderenSchema"],
        storedData: this.storedChildren[index],
        wezentoeslag: false,
      });
      this.sortChildren();
      for (var c in this.$children) {
        this.$children[c].fetchResults();
      }
    },
    updatename: function (index, name) {
      this.children[index].naam = name;
    },
    wezentoeslag: function (index) {
      this.children[index].wezentoeslag = true;
    },
    gitcorrection: function () {
      this.gitcorr = true;
    },
    addChild: function () {
      this.children.push({
        key: uuid(),
        naam: "",
        jongsteCounter: "1",
        childCounter: 1,
        birthDate: "",
        continuedRight: "nieuw recht",
        storedData: {},
        wezentoeslag: false,
      });
      this.show = false;
    },
    globalQuestion: function (node, answer) {
      this.global_questions[node] = answer;
    },
    continuedRight: function (name, right) {
      this.children.forEach((child, index) => {
        if (child.naam == name) {
          this.children[index].continuedRight = right;
        }
      });
      if (right == "nieuw recht") {
        this.gezinHeeftPost2019Kind = 1;
      }
      this.sortChildren();
    },
    doSortChildren() {
      this.sortChildren();
    },
    updateBirthdate: function (naam, birthdate) {
      //console.log("debug");
      this.children.forEach((child, index) => {
        if (child.naam == naam) {
          this.children[index].birthDate = birthdate;
        }
      });
      if (birthdate >= "2019-01-01") {
        this.gezinHeeftPost2019Kind = 1;
      }
      this.sortChildren();
    },
    groupBy: function (xs, prop) {
      var grouped = {};
      for (var i = 0; i < xs.length; i++) {
        var p = xs[i][prop];
        if (!grouped[p]) {
          grouped[p] = [];
        }
        grouped[p].push(xs[i]);
      }
      return grouped;
    },
    sortChildren: function () {
      try {
        var sortedChildren = JSON.parse(JSON.stringify(this.children));
        var s = this.groupBy(sortedChildren, "continuedRight");
        var wezentoeslag = 0;
        try {
          var n = JSON.parse(JSON.stringify(s["nieuw recht"]));
          if (this.region == "WA") {
            //Remove children without BB_EUR from jongste- and childcounter
            var n1 = JSON.parse(JSON.stringify(s["nieuw recht"]));
            n1.forEach((achild, ainex) => {
              if (this.result[achild["naam"]]) {
                if (!this.result[achild["naam"]]["BB_EUR"]) {
                  var index = n.findIndex((i) => i.key === achild["key"]);
                  n.splice(index, 1);
                }
              }
            });
          }

          // Sort on birthdate
          n.sort(function (a, b) {
            return new Date(a.birthDate) - new Date(b.birthDate);
          });

          var m = new Array();
          n.forEach((achild, aindex) => {
            if (
              (new Date() - new Date(achild.birthDate)) /
                1000 /
                3600 /
                24 /
                365 <
              25
            ) {
              m.push(achild);
            }
          });
          n = JSON.parse(JSON.stringify(m));
          var childCounter = 0; // Reset childCounter for "nieuw recht"
          n.forEach((schild, sindex) => {
            this.children.forEach((child, index) => {
              if (schild.naam == child.naam) {
                if (schild.wezentoeslag) {
                  wezentoeslag++;
                }
                childCounter++;
                child.childCounter = childCounter - wezentoeslag;
                if (n.length - sindex == 1) {
                  child.jongsteCounter = "1";
                } else if (n.length - sindex == 2) {
                  child.jongsteCounter = "2";
                } else {
                  child.jongsteCounter = ">=3";
                }
              }
            });
          });
        } catch (e) {
          console.log(e);
        }

        try {
          var v = JSON.parse(JSON.stringify(s["voortgezet recht"]));

          //Remove children without BB_EUR from jongste- and childcounter
          var v1 = JSON.parse(JSON.stringify(s["voortgezet recht"]));
          v1.forEach((achild, ainex) => {
            if (this.result[achild["naam"]]) {
              if (!this.result[achild["naam"]]["BB_EUR"]) {
                var index = v.findIndex((i) => i.key === achild["key"]);
                v.splice(index, 1);
              }
            }
          });
          v.sort(function (a, b) {
            return new Date(a.birthDate) - new Date(b.birthDate);
          });
          //wezentoeslag = 0;
          childCounter = 0; // Reset childCounter for "voortgezet recht"
          v.forEach((schild, sindex) => {
            this.children.forEach((child, index) => {
              if (schild.naam == child.naam) {
                if (schild.wezentoeslag) {
                  wezentoeslag++;
                }
                childCounter++;
                child.childCounter = childCounter - wezentoeslag;
                if (v.length - index - wezentoeslag == 1) {
                  child.jongsteCounter = "1";
                } else if (v.length - index - wezentoeslag == 2) {
                  child.jongsteCounter = "2";
                } else if (v.length - index - wezentoeslag == 0) {
                  child.jonsteCounter = "0";
                } else {
                  child.jongsteCounter = ">=3";
                }
              }
            });
          });
        } catch (e) {
          console.log(e);
        }
      } catch (e) {
        console.log(e);
      }
    },
    getResultsHandler: function (data, index) {
      this.result[index] = data;
      this.sortChildren();
      this.bedragen();
    },

    bedragen: function () {
      let res = 0;
      let counter = 0;
      for (var child in this.result) {
        for (var amount in this.result[child]) {
          if (amount == "BB_EUR") {
            counter += 1;
          }
        }
      }
      this.childCountTotal = counter;
      for (var child in this.result) {
        for (var amount in this.result[child]) {
          res += parseFloat(this.result[child][amount]);
          var gitcorr_value = 0;
          if (this.gitcorr && this.region == "WA") {
            if (this.global_questions["gezinsInkomen"] == "< 31.603,68") {
              gitcorr_value = 35.7;
            } else if (
              this.global_questions["gezinsInkomen"] ==
              ">= 31.603,68; < 51.000,00"
            ) {
              gitcorr_value = 20.4;
            }
          }
          if (
            amount == "GIT_EUR" &&
            [86.7, 76.5, 66.3, 56.1, 35.7, 25.5].includes(
              parseFloat(this.result[child][amount]),
            ) &&
            this.gitcorr &&
            this.childCountTotal > 2
          ) {
            res += gitcorr_value;
            this.result[child][amount] =
              parseFloat(this.result[child][amount]) + gitcorr_value;
          }
          if (amount == "BB_EUR") {
            counter += 1;
          }
        }
      }

      this.sumresult = res.toFixed(2);
    },

    isEmpty: function (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    refreshsim: function () {
      location.reload();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.refreshsim {
  cursor: pointer;
  right: 10%;
  position: absolute;
}
.cb_sim_btn_blue {
  font-family: "Museo Sans", Helvetica, Arial, sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -webkit-box-direction: normal;
  box-sizing: border-box;
  text-decoration: none;
  display: inline-block;
  color: #ffffff;
  background: #2c7794;
  padding: 1.1rem 4rem 1rem 2rem;
  background-color: #2c7794;
  /*background-image: url("../img/icons/icon__arrow--red.svg");*/
  background-repeat: no-repeat;
  background-position: right 1.5rem center;
  background-size: 1rem 1.7rem;
  font-size: 1.6rem;
  font-weight: bold;
  line-height: 1.9rem;
  text-align: center;
  border: 0;
  border-radius: 2.45rem;
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.cb_sim_children {
  /* transform: scale(0.8); */
  font-family: "Museo Sans", Helvetica, Arial, sans-serif;
  font-size: 1.6rem;
  font-weight: normal;
  line-height: 1.625;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  color: #2c3e50;
  box-sizing: border-box;
  margin: 0;
  padding: 3.5rem 4rem;
  border-radius: 0.4rem;
  -webkit-box-flex: 0;
  flex: 0 1 58%;
  background-color: #fff;
}

.cb_sim_results {
  /* transform: scale(0.8); */
  font-family: "Museo Sans", Helvetica, Arial, sans-serif;
  font-size: 1.6rem;
  font-weight: normal;
  line-height: 1.625;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  color: #423132;
  box-sizing: border-box;
  margin: 0;
  padding: 3.5rem 4rem;
  border-radius: 0.4rem;
  -webkit-box-flex: 0;
  flex: 0 1 40%;
  background-color: #ffffff;
  position: relative;
  min-height: 50rem;
}
.cb_sim_container {
  transform: scale(0.8);
  font-family: "Museo Sans", Helvetica, Arial, sans-serif;
  font-size: 1.6rem;
  font-weight: normal;
  line-height: 1.625;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: stretch;
  align-items: stretch;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 5rem;
  background-color: #fef0e0;
}
.cb_btn {
  display: inline-block;
  /*margin: 0.5rem;
  padding: 0.5rem;*/
  border-radius: 0.5rem;
  border: 1px solid grey;
  font-size: 1.5rem;
  height: 100%;
  color: white;
  max-width: 1.8rem;
}
.cb_btn:hover {
  cursor: pointer;
}

.cb_btn_noborder {
  border: 0;
}

#cb_sim_disclaimer {
  font-size: 1.3rem;
  bottom: 0;
  position: absolute;
  margin: 2em;
  left: 0;
  right: 0;
}

.cb_sim_calcfor {
  font-size: 2rem;
}

.cb_sim_result {
  padding-left: 1rem;
  margin-bottom: 1rem;
}

.cb_sim_result li {
  padding-left: 1rem;
  list-style: none;
  font-size: 1.5rem;
}
.cb_sim_resultname {
}

.cb_sim_resultamount {
  right: 4rem;
  position: absolute;
}
.cb_sim_h3_totalresult {
  font-size: 2rem;
}

@media (max-width: 48rem) {
  .cb_sim_children {
    /* transform: scale(0.8); */
    font-family: "Museo Sans", Helvetica, Arial, sans-serif;
    font-size: 1.6rem;
    font-weight: normal;
    line-height: 1.625;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    color: #2c3e50;
    box-sizing: border-box;
    margin: 0;
    padding: 3.5rem 4rem;
    border-radius: 0.4rem;
    -webkit-box-flex: 0;
    flex: 0 1 100%;
    background-color: #fff;
    order: 1;
  }

  .cb_sim_results {
    /* transform: scale(0.8); */
    font-family: "Museo Sans", Helvetica, Arial, sans-serif;
    font-size: 1.6rem;
    font-weight: normal;
    line-height: 1.625;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    color: #2c3e50;
    box-sizing: border-box;
    margin: 0;
    padding: 3.5rem 4rem;
    border-radius: 0.4rem;
    -webkit-box-flex: 0;
    flex: 0 1 100%;
    background-color: #ffffff;
    position: relative;
    min-height: 50rem;
    order: 2;
  }
}
</style>
